import { PlayerLanding } from "./PlayerLanding";

export function PlayerRoute() {
  return <PlayerLanding />;
}
